import React from 'react'
import RateUsComp from '../components/BookCourt/RateUsComp'

const RateUs = () => {
  return (
    <>
        <RateUsComp/>  
    </>
  )
}

export default RateUs